const debug = false;

//used when in the spreadsheet we have % number
const pc = c => c / 100;

const currencyFormat = { style: 'currency', currency: 'USD'};
const numberFormatToCurrency = new Intl.NumberFormat('en-US', currencyFormat);

function log(name, value) {
    console.log('%c' + name + ' %c ' + value, 'color: white; border: 1px solid grey; background: black', 'color: lightblue;');
}

function verifySwitchStatus($elem) {
    var isCustomerCalc = $elem.prop('checked');
    if (isCustomerCalc) {
        $('.saasUI').addClass('d-none');
        $('.consumerAppUI').removeClass('d-none');
        $('#consumer-app-calc-label').addClass('font-weight-bold');
        $('#consumer-app-calc-label-mobile').addClass('font-weight-bold');
        $('#saas-calc-label').removeClass('font-weight-bold');
        $('#saas-calc-label-mobile').removeClass('font-weight-bold');

        initConsumerSlider();
    } else {
        $('.saasUI').removeClass('d-none');
        $('.consumerAppUI').addClass('d-none');
        $('#consumer-app-calc-label').removeClass('font-weight-bold');
        $('#consumer-app-calc-label-mobile').removeClass('font-weight-bold');
        $('#saas-calc-label').addClass('font-weight-bold');
        $('#saas-calc-label-mobile').addClass('font-weight-bold');

        initSaasSlider();
    }
}

$(function() {
    var elemSwitch = document.querySelector('.js-switch');
    new Switchery(elemSwitch, {
        // primary color
        color: '#16ad6f',
        // secondary color
        secondaryColor: '#16ad6f',
        // primary handle color
        jackColor: '#fff',
        // default CSS class
        className: 'switchery',
        // animation speed
        speed: '0.4s',
        size: 'small'
    });

    verifySwitchStatus($(elemSwitch));

    elemSwitch.onchange = function() {
        verifySwitchStatus($(this));
    };

    //------- js swith mobile -------    
    var elemSwitchMobile = document.querySelector('.js-switch-mobile');
    new Switchery(elemSwitchMobile, {
        // primary color
        color: '#16ad6f',
        // secondary color
        secondaryColor: '#16ad6f',
        // primary handle color
        jackColor: '#fff',
        // default CSS class
        className: 'switchery',
        // animation speed
        speed: '0.4s',
        size: 'small'
    });

    verifySwitchStatus($(elemSwitchMobile));

    elemSwitchMobile.onchange = function() {
        verifySwitchStatus($(this));
    };


    $('#saasResetBenchmarkLink').on('click', function() {
        initSaasCalc();
    });

    $('#consumerAppresetBenchmarkLink').on('click', function() {
        initConsumerAppCalc();
    });
});


//++++++++++++++++++++++++++++++++++
var increaseInUserActivation;

var UARPercentage;
var monthlyCustomerChurnPercentage;
var ARPAMonthly;
var trialsStartedPerMonth;

var trialToPayImproved;
var trialToPayBench;
var trialToPayDiff;
var monthlyCustomerChurn1;
var monthlyCustomerChurn2;
var monthlyCustomerChurn3;
var lifeTimeValue1;
var lifeTimeValue2;
var lifeTimeValue3;

var MRRLifetimeBenchArray;
var MRRLifetimeBenchArrayTotal;
var MRRLifetimeImprovedArray;
var MRRLifetimeImprovedArrayTotal;
var lifetimeMonthsArray;
var MRRLifetimetotalDiff;
var MRRLifetimetotalDiffPercentage;

var saasSlider;
var saasSliderValue;
var saasCalculatorChart;

$(function() {
    //*************** INIT ***************** */    
    initSaasCalc();

    //------------- EVENT HANDLERS -------------

    $('#txtUserActivationRate, #txtMonthlyCustomerChurn, #txtAvgMmonthlySubcription, #txtTrialsStartedPerMonth')
        .change(function() {
            recalculate();
        });
});

function initSaasCalc() {

    calulateVariables();
    setUIValues();
    initSaasSlider(0);

    //*************** CHART ***************** */
    var chartOptions = {
        animation: {
            duration: 0
        },
        legend: {
            display: false
        },
        elements: {
          line: {
              tension: 0.1 // disables bezier curves
          }
        },
        responsive: true, // Instruct chart js to respond nicely.
        maintainAspectRatio: true, // Add to prevent default behaviour of full-width/height,
        tooltips: {
            enabled: true,
            mode: 'index',
            intersect: false,
            titleFontSize: 14,
            bodyFontSize: 12,
            bodySpacing: 10,
            callbacks: {
                label: function(tooltipItem, data) {
                  return numberFormatToCurrency.format(tooltipItem.yLabel).split('.')[0];
                },
                title: function(tooltipItem, data) {
                  return "MRR";
                },
            },
            itemSort: function(a, b) {
             return b.datasetIndex - a.datasetIndex
            }
        },
        scales: {
            yAxes: [{
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function(value, index, values) {
                        return '$' + (value / 1000) + 'k';
                    }
                },
                scaleLabel: {
                    display: true,
                    labelString: 'Monthly recurring rev.'
                }
            }],
            xAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: 'Customer lifetime (months)'
                },
                gridLines : {
                  display : false
                }
            }]
        }
    };

    var ctx = document.getElementById('saasCalculatorChart');
    saasCalculatorChart = new Chart(ctx, {
        type: 'line',
        data: setChartData(),
        options: chartOptions
    });
}

function initSaasSlider(defaultValue) {
    saasSlider = document.getElementById("saasSlider");

    if (defaultValue != undefined) {
        saasSlider.value = defaultValue;
        saasSliderValue = defaultValue;
        $('#saasSliderValue').text(defaultValue);
    }

    // Update the current slider value (each time you drag the slider handle)
    saasSlider.oninput = function() {
        $('#saasSliderValue').text(this.value);
        saasSliderValue = this.value;
        recalculate();
    };
}

function resetSaasCalculator() {
    initSaasCalc();
}

function calulateVariables(
    increaseInUserActivationVal = 0,
    UARPercentageVal = 25,
    monthlyCustomerChurnPercentageVal = 5.5,
    ARPAMonthlyVal = 100,
    trialsStartedPerMonthVal = 300
) {

    ///////////////// EDITABLE BY USER ////////////////////
    increaseInUserActivation = pc(increaseInUserActivationVal);

    // BENCHMARKS
    UARPercentage = pc(UARPercentageVal);
    monthlyCustomerChurnPercentage = pc(monthlyCustomerChurnPercentageVal);
    ARPAMonthly = ARPAMonthlyVal;
    trialsStartedPerMonth = trialsStartedPerMonthVal;
    var improvedUARPercentage = UARPercentage * (1 + increaseInUserActivation);
    ///////////////////////////////////////////////////////

    // --- Active user data ---
    var activatedUserCountBench = trialsStartedPerMonth * UARPercentage;
    var activatedUserCountImproved = trialsStartedPerMonth * improvedUARPercentage;
    const ACTIVATE_USER_CONVERSION_RATE = 0.4; //(non active is~0.1)
    var nonActivatedUserCountBench = trialsStartedPerMonth - activatedUserCountBench;
    var nonActivatedUserCountImproved = trialsStartedPerMonth - activatedUserCountImproved;
    const NON_ACTIVATE_USER_CONVERSION_RATE = 0.1;

    // --- Trial to paid data PART #1 --- 
    var trialToPaidCountBench = (activatedUserCountBench * ACTIVATE_USER_CONVERSION_RATE) + (nonActivatedUserCountBench * NON_ACTIVATE_USER_CONVERSION_RATE);
    var trialToPaidCountImproved = (activatedUserCountImproved * ACTIVATE_USER_CONVERSION_RATE) + (nonActivatedUserCountImproved * NON_ACTIVATE_USER_CONVERSION_RATE);
    var monthlyRetentionBenchPercentage = (100 - (monthlyCustomerChurnPercentage * 100)) / 100;

    // --- Assorted data PART #1 ---
    var UARAbsoluteIncreasePercentage = parseFloat((improvedUARPercentage - UARPercentage).toString().substr(0, 5));

    var month1AdditionalCustomerImprovedAbsoluteCountFromNonActivatedCustomers =
        (nonActivatedUserCountImproved * NON_ACTIVATE_USER_CONVERSION_RATE) * UARAbsoluteIncreasePercentage;

    var month1AdditionalCustomerImprovedAbsoluteCountFromActivatedCustomers = ((activatedUserCountImproved * ACTIVATE_USER_CONVERSION_RATE) * UARAbsoluteIncreasePercentage);

    var month1RetentionIncreasePercentage =
        month1AdditionalCustomerImprovedAbsoluteCountFromNonActivatedCustomers / trialToPaidCountImproved;

    var annualRetentionImprovedPercentage =
        Math.pow((1 - monthlyCustomerChurnPercentage), 12) + month1RetentionIncreasePercentage;

    var annualChurnBenchmarkPercentage = 1 -
        Math.pow((1 - monthlyCustomerChurnPercentage), 12);

    var annualChurnImprovedPercentage = 1 - annualRetentionImprovedPercentage;
    var customerLifetimeMonthsBenchmark = 1 / monthlyCustomerChurnPercentage;
    var customerLifetimeMonthsBenchmarkRounded = Math.round(customerLifetimeMonthsBenchmark);

    // MONTHLY CUSTOMER CHURN
    monthlyCustomerChurn1 = (1 - Math.pow((1 - annualChurnImprovedPercentage), (1 / 12)));

    monthlyCustomerChurn2 = (monthlyCustomerChurn1 - monthlyCustomerChurnPercentage) / monthlyCustomerChurn1;

    monthlyCustomerChurn3 = 1 - Math.pow((1 - annualChurnBenchmarkPercentage), (1 / 12));

    // --- Assorted data PART #2 ---
    var customerLifetimeMonthsImproved = 1 / monthlyCustomerChurn1;
    var customerLifetimeMonthsImprovedRounded = Math.round(customerLifetimeMonthsImproved);

    // --- Trial to paid data PART #2 ---
    var monthlyRetentionImprovedPercentage = 1 - monthlyCustomerChurn1;

    //----------------------------------------

    // TRIAL TO PAID
    trialToPayImproved = (trialToPaidCountImproved / trialsStartedPerMonth);
    trialToPayBench = (trialToPaidCountBench / trialsStartedPerMonth);
    trialToPayDiff = (trialToPayImproved - trialToPayBench) / trialToPayBench;

    // LIFETIME VALUE
    lifeTimeValue1 = ARPAMonthly * customerLifetimeMonthsImproved;
    lifeTimeValue2 = Math.round(((ARPAMonthly * customerLifetimeMonthsBenchmark).toFixed(2) * 100)) / 100;
    lifeTimeValue3 = (lifeTimeValue1 - lifeTimeValue2) / lifeTimeValue2;

    //************************************************************************* */

    //---------- MRR lifetime (bench) ----------
    MRRLifetimeBenchArray = new Array();

    for (var i = 0; i < customerLifetimeMonthsBenchmarkRounded; i++) {
        if (i === 0) {
            var customers = trialToPaidCountBench * monthlyRetentionBenchPercentage;
            MRRLifetimeBenchArray.push({
                'customers': customers,
                'value': customers * ARPAMonthly
            });
        } else {
            var customers = (MRRLifetimeBenchArray[i - 1].customers + trialToPaidCountBench) * monthlyRetentionBenchPercentage;
            MRRLifetimeBenchArray.push({
                'customers': customers,
                'value': customers * ARPAMonthly
            });
        }
    }

    MRRLifetimeBenchArrayTotal = MRRLifetimeBenchArray.reduce(function(a, b) {
        return a + (b['value'] || 0);
    }, 0);

    //----------- MRR lifetime (improved) ---------
    MRRLifetimeImprovedArray = new Array();

    for (var i = 0; i < customerLifetimeMonthsImprovedRounded; i++) {
        if (i === 0) {
            var customers = trialToPaidCountImproved * monthlyRetentionImprovedPercentage;
            MRRLifetimeImprovedArray.push({
                'customers': customers,
                'value': customers * ARPAMonthly
            });
        } else {
            var customers = (MRRLifetimeImprovedArray[i - 1].customers + trialToPaidCountImproved) * monthlyRetentionImprovedPercentage;
            MRRLifetimeImprovedArray.push({
                'customers': customers,
                'value': customers * ARPAMonthly
            });
        }
    }

    MRRLifetimeImprovedArrayTotal = MRRLifetimeImprovedArray.reduce(function(a, b) {
        return a + (b['value'] || 0);
    }, 0);


    //---------- lifetime (months) -----------
    lifetimeMonthsArray = new Array();

    for (var i = 1; i < customerLifetimeMonthsImprovedRounded + 1; i++) {
        lifetimeMonthsArray.push(i);
    }

    MRRLifetimetotalDiff = MRRLifetimeImprovedArrayTotal - MRRLifetimeBenchArrayTotal;
    MRRLifetimetotalDiffPercentage = Math.round((parseFloat((MRRLifetimetotalDiff / MRRLifetimeBenchArrayTotal).toFixed(4)) * 100) * 100) / 100;
    //----------------------------------------

    if (debug) {
        // ***** LOGS *******
        console.log('//////////////////////////// SAAS ///////////////////////////////////////////');
        log('INCREASE IN USER ACTIVATION:', increaseInUserActivation);
        log('Improved UAR Percentage', improvedUARPercentage);

        console.log('------------ BENCHMARKS ------------');
        log('UAR Percentage', UARPercentage);
        log('Monthly Customer Churn Percentage', monthlyCustomerChurnPercentage);
        log('ARPA Monthly', ARPAMonthly);
        log('Trials Started Per Month', trialsStartedPerMonth);

        console.log('-------- Active user data ----------');
        log('Activated User Count Bench', activatedUserCountBench);
        log('Activated User Count Improved', activatedUserCountImproved);
        log('ACTIVATE USER CONVERSION RATE', ACTIVATE_USER_CONVERSION_RATE);
        log('NON Activated User Count Bench', nonActivatedUserCountBench);
        log('NON Activated User Count Improved', nonActivatedUserCountImproved);
        log('NON ACTIVATE USER CONVERSION RATE', NON_ACTIVATE_USER_CONVERSION_RATE);

        console.log('-------- Trial to paid data ----------');
        log('Trial To Paid Count Bench', trialToPaidCountBench);
        log('Trial To Paid Count Improved', trialToPaidCountImproved);
        log('Monthly Retention Bench Percentage', monthlyRetentionBenchPercentage);
        log('Monthly Retention Improved Percentage', monthlyRetentionImprovedPercentage);

        console.log('-------- Assorted data ----------');
        log('UAR Absolute Increase Percentage', UARAbsoluteIncreasePercentage);
        log('Month 1 Additional Customer Improved Absolute Count From NON Activated Customers', month1AdditionalCustomerImprovedAbsoluteCountFromNonActivatedCustomers);
        log('Month 1 Additional Customer Improved Absolute Count From Activated Customers', month1AdditionalCustomerImprovedAbsoluteCountFromActivatedCustomers);

        log('Month 1 Retention Increase Percentage', month1RetentionIncreasePercentage);
        log('Annual Retention Improved Percentage', annualRetentionImprovedPercentage);
        log('Annual Churn Benchmark Percentage', annualChurnBenchmarkPercentage);
        log('Annual Churn Improved Percentage', annualChurnImprovedPercentage);
        log('Customer Lifetime Months Benchmark', customerLifetimeMonthsBenchmark);
        log('Customer Lifetime Months Benchmark Rounded', customerLifetimeMonthsBenchmarkRounded);
        log('Customer Lifetime Months Improved', customerLifetimeMonthsImproved);
        log('Customer Lifetime Months Improved Rounded', customerLifetimeMonthsImprovedRounded);

        console.log('-------- TRIAL TO PAID ----------');
        log('Trial To Pay Improved', trialToPayImproved);
        log('Trial To Pay Bench', trialToPayBench);
        log('Trial To Pay Diff', trialToPayDiff);

        console.log('-------- MONTHLY CUSTOMER CHURN ----------');
        log('Monthly Customer Churn 1', monthlyCustomerChurn1);
        log('Monthly Customer Churn 2', monthlyCustomerChurn2);
        log('Monthly Customer Churn 3', monthlyCustomerChurn3);

        console.log('-------- LIFETIME VALUE ----------');
        log('Life Time Value 1', lifeTimeValue1);
        log('Life Time Value 2', lifeTimeValue2);
        log('Life Time Value 3', lifeTimeValue3);

        console.log('-------- TOTAL RECURRING REVENUE ----------');
        log('MRR Lifetime Bench Total', MRRLifetimeBenchArrayTotal);
        log('MRR Lifetime Improved Total', MRRLifetimeImprovedArrayTotal);
        console.log('///////////////////////////////////////////////////////////////////////');
    }
}

function recalculate() {

    calulateVariables(
        increaseInUserActivationVal = saasSliderValue,
        UARPercentageVal = parseFloat($('#txtUserActivationRate').val()),
        monthlyCustomerChurnPercentageVal = parseFloat($('#txtMonthlyCustomerChurn').val()),
        ARPAMonthlyVal = parseFloat($('#txtAvgMmonthlySubcription').val()),
        trialsStartedPerMonthVal = parseFloat($('#txtTrialsStartedPerMonth').val())
    );

    setUIValues();

    updateChart();
}

function setUIValues() {
    if ($('#saasSliderValue').text() == "0") {
      $('#revenueOutputUI').hide();
      $('.arrow_lg').hide();
    } 
    else{
      $('#revenueOutputUI').show();
      $('.arrow_lg').show();
    }


    var totalRecurringRevenueVal = (MRRLifetimeImprovedArrayTotal === MRRLifetimeBenchArrayTotal ? "--" : MRRLifetimeImprovedArrayTotal);
    var MRRLifetimetotalDiffVal = (MRRLifetimetotalDiff === 0 ? "--" : numberFormatToCurrency.format(MRRLifetimetotalDiff).split('.')[0]);


    $('#totalRecurringRevenueUI').html(numberFormatToCurrency.format(totalRecurringRevenueVal).split('.')[0]);
    $('#MRRLifetimeBenchTotalUI').html(numberFormatToCurrency.format(MRRLifetimeBenchArrayTotal).split('.')[0]);
    $('#MRRLifetimetotalDiffUI').html(MRRLifetimetotalDiffVal);
    $('#MRRLifetimetotalDiffPercentageUI').html(MRRLifetimetotalDiffPercentage.toFixed(0) + '%');

    $('#totalRecurringRevenueOutputUI').html(numberFormatToCurrency.format(totalRecurringRevenueVal).split('.')[0] + 'up' + MRRLifetimetotalDiffPercentage + '%');
    $('#revenueOutputUI').removeClass('invisible');

    var trialToPayImprovedRounded = (trialToPayImproved > trialToPayBench ? (trialToPayImproved * 100).toFixed(1) + '%' : "--");
    $('#trialToPaidUI').html(trialToPayImprovedRounded);
    var trialToPayBenchRounded = (trialToPayBench * 100).toFixed(2);
    $('#trialToPayBenchUI').html(trialToPayBenchRounded + '%');
    var trialToPayDiffRounded = (trialToPayDiff * 100).toFixed(2);
    $('#trialToPayDiffUI').html(trialToPayDiffRounded + '%');

    var monthlyCustomerChurn1Rounded = parseFloat((monthlyCustomerChurn1 * 100).toFixed(2));
    var monthlyCustomerChurn3Rounded = parseFloat((monthlyCustomerChurn3 * 100).toFixed(2));
    var monthlyCustomerChurn2Rounded = (Math.abs(monthlyCustomerChurn2) * 100).toFixed(2);
    $('#monthlyCustomerChurn1UI').html((monthlyCustomerChurn1Rounded === monthlyCustomerChurn3Rounded ? "--" : monthlyCustomerChurn1Rounded + '%'));
    $('#monthlyCustomerChurn3UI').html(monthlyCustomerChurn3Rounded + '%');
    $('#monthlyCustomerChurn2UI').html(monthlyCustomerChurn2Rounded + '%');


    $('#lifetimeValue1UI').html(lifeTimeValue1.toFixed(2) == lifeTimeValue2 ? "--" : numberFormatToCurrency.format(lifeTimeValue1).split('.')[0]);
    $('#lifetimeValue2UI').html(numberFormatToCurrency.format(lifeTimeValue2).split('.')[0]);
    var lifetimeValue3Rounded = (lifeTimeValue3 * 100).toFixed(2);
    $('#lifetimeValue3UI').html(lifetimeValue3Rounded + '%');
    $('#uarTotalSaasUI').text(((UARPercentage * (1 + increaseInUserActivation)) * 100).toFixed(1) + '%');
    $('#txtUserActivationRate').val(UARPercentage * 100);
    $('#txtMonthlyCustomerChurn').val(monthlyCustomerChurnPercentage * 100);
    $('#txtAvgMmonthlySubcription').val(ARPAMonthly);
    $('#txtTrialsStartedPerMonth').val(trialsStartedPerMonth);
}

function setChartData() {
    return {
        labels: lifetimeMonthsArray,
        datasets: [{
                data: MRRLifetimeBenchArray.map(x => x.value),
                fill: true,
                borderColor: '#5EC887', // Add custom color border (Line)
                backgroundColor: '#E3FAEC', // Add custom color background (Points and Fill)
                borderWidth: 1 // Specify bar border width
            },
            {
                data: MRRLifetimeImprovedArray.map(x => x.value),
                fill: true,
                borderColor: '#3A975E', // Add custom color border (Line)
                backgroundColor: '#91f4c3', // Add custom color background (Points and Fill)
                borderWidth: 1 // Specify bar border width
            }
        ]
    };
}

function updateChart() {
    if (saasCalculatorChart != undefined) {

        saasCalculatorChart.data = setChartData(
            lifetimeMonthsArray,
            MRRLifetimeBenchArray.map(x => x.value),
            MRRLifetimeImprovedArray.map(x => x.value));

        saasCalculatorChart.update();
    }
}



//+++++++++++++++++++++++++++++++
var consumer_increaseInUserActivation;

var consumer_UARPercentage;
var ARPUMonthly;
var monthlyDownloads;

var _90DayUserRetentionTotalPercentage;
var _90DayUserRetentionFrom;
var _90DayUserRetentionDiff;

var weeklyActiveUsersTotal;
var weeklyActiveUsersFrom;
var weeklyActiveUsersDiff;

var consumerLifeTimeValueTotal;
var consumerLifeTimeValueFrom;
var consumerLifeTimeValueDiff;

var milestonesRetentionArray;

var consumerSlider;
var consumerSliderValue;
var consumerCalculatorChart;

$(function() {
    //*************** INIT ***************** */    
    initConsumerAppCalc();

    //------------- EVENT HANDLERS -------------

    $('#txtUserActivationRateCustomer, #txtAvgMonthlyRevenuePerUser, #txtMonthlyAppDownloads')
        .change(function() {
            recalculateConsumer();
        });
});

function initConsumerAppCalc() {

    calulateCustomerVariables();
    setCustomerUIValues();

    initConsumerSlider(0);

    //*************** CHART ***************** */
    var chartConsumerOptions = {
        animation: {
            duration: 0
        },
        legend: {
            display: false
        },
        elements: {
          line: {
              tension: 0.1 // disables bezier curves
          }
        },
        responsive: true, // Instruct chart js to respond nicely.
        maintainAspectRatio: true, // Add to prevent default behaviour of full-width/height,
        tooltips: {
            enabled: true,
            mode: 'index',
            intersect: false,
            titleFontSize: 14,
            bodyFontSize: 12,
            bodySpacing: 10,
            callbacks: {
                label: function(tooltipItem, data) {
                  return tooltipItem.yLabel.toFixed(1) + '%';
                },
                title: function(tooltipItem, data) {
                  return "Active users";
                },
            },
            itemSort: function(a, b) {
             return b.datasetIndex - a.datasetIndex
            }
        },
        scales: {
            yAxes: [{
                /*ticks: {
                    callback: function(value, index, values) {
                        return numberFormatToCurrency.format(value);
                    }
                },*/
                scaleLabel: {
                    display: true,
                    labelString: '% of active users'
                }
            }],
            xAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: 'Days since app install'
                },
                gridLines : {
                  display : false
              }
            }]
        }
    };

    var ctx = document.getElementById('consumerCalculatorChart');
    consumerCalculatorChart = new Chart(ctx, {
        type: 'line',
        data: setConsumerChartData(),
        options: chartConsumerOptions
    });

}

function initConsumerSlider(defaultValue) {
    consumerSlider = document.getElementById("consumerSlider");

    if (defaultValue != undefined) {
        consumerSlider.value = defaultValue;
        consumerSliderValue = defaultValue;
        $('#consumerSliderValue').text(defaultValue);
    }

    // Update the current slider value (each time you drag the slider handle)
    consumerSlider.oninput = function() {
        $('#consumerSliderValue').text(this.value);
        consumerSliderValue = this.value;
        recalculateConsumer();
    };
}

function calulateCustomerVariables(
    consumer_increaseInUserActivationVal = 0,
    consumer_UARPercentageVal = 30,
    ARPUMonthlyVal = 4,
    monthlyDownloadsVal = 1500
) {

    ///////////////// EDITABLE BY USER ////////////////////
    consumer_increaseInUserActivation = pc(consumer_increaseInUserActivationVal);

    // BENCHMARKS
    consumer_UARPercentage = pc(consumer_UARPercentageVal);
    ARPUMonthly = ARPUMonthlyVal;
    monthlyDownloads = monthlyDownloadsVal;

    var consumer_improvedUARPercentage = consumer_UARPercentage * (1 + consumer_increaseInUserActivation);
    ///////////////////////////////////////////////////////

    // --- Retention data ---
    const RETENTION_DATA_PERCENTAGE = pc(15);
    var D1RetentionRateBench = (consumer_UARPercentage * (1 - RETENTION_DATA_PERCENTAGE));
    var D1RetentionRateImproved = (consumer_improvedUARPercentage * (1 - RETENTION_DATA_PERCENTAGE));
    var D1D90RetentionPointIncrease = (D1RetentionRateImproved * 100) - (D1RetentionRateBench * 100);

    //row 1
    milestonesRetentionArray = [
        //milestones (days) | retention curve blueprint (bench) |  retention curve (bench) | difference btwn milestones | retention curve (improved)
        [0, 100, 100, 0, 100]
    ];

    //row 2
    milestonesRetentionArray.push([
        1,
        29.17,
        D1RetentionRateBench * 100,
        Math.abs((29.17 - milestonesRetentionArray[0][1]) / milestonesRetentionArray[0][1]),
        (D1RetentionRateBench * 100) + D1D90RetentionPointIncrease
    ]);

    //row 3
    milestonesRetentionArray.push([
        3,
        23.42,
        0,
        Math.abs((23.42 - milestonesRetentionArray[1][1]) / milestonesRetentionArray[1][1]),
        0
    ]);
    milestonesRetentionArray[2][2] = (milestonesRetentionArray[1][2] * (1 - milestonesRetentionArray[2][3]));
    milestonesRetentionArray[2][4] = milestonesRetentionArray[2][2] + D1D90RetentionPointIncrease;

    //row 4
    milestonesRetentionArray.push([
        7,
        17.28,
        0,
        Math.abs((17.28 - milestonesRetentionArray[2][1]) / milestonesRetentionArray[2][1]),
        0
    ]);
    milestonesRetentionArray[3][2] = (milestonesRetentionArray[2][2] * (1 - milestonesRetentionArray[3][3]));
    milestonesRetentionArray[3][4] = milestonesRetentionArray[3][2] + D1D90RetentionPointIncrease;

    //row 5
    milestonesRetentionArray.push([
        14,
        13.11,
        0,
        Math.abs((13.11 - milestonesRetentionArray[3][1]) / milestonesRetentionArray[3][1]),
        0
    ]);
    milestonesRetentionArray[4][2] = (milestonesRetentionArray[3][2] * (1 - milestonesRetentionArray[4][3]));
    milestonesRetentionArray[4][4] = milestonesRetentionArray[4][2] + D1D90RetentionPointIncrease;

    //row 6
    milestonesRetentionArray.push([
        30,
        9.55,
        0,
        Math.abs((9.55 - milestonesRetentionArray[4][1]) / milestonesRetentionArray[4][1]),
        0
    ]);
    milestonesRetentionArray[5][2] = (milestonesRetentionArray[4][2] * (1 - milestonesRetentionArray[5][3]));
    milestonesRetentionArray[5][4] = milestonesRetentionArray[5][2] + D1D90RetentionPointIncrease;

    //row 7
    milestonesRetentionArray.push([
        60,
        6.82,
        0,
        Math.abs((6.82 - milestonesRetentionArray[5][1]) / milestonesRetentionArray[5][1]),
        0
    ]);
    milestonesRetentionArray[6][2] = (milestonesRetentionArray[5][2] * (1 - milestonesRetentionArray[6][3]));
    milestonesRetentionArray[6][4] = milestonesRetentionArray[6][2] + D1D90RetentionPointIncrease;

    //row 8
    milestonesRetentionArray.push([
        90,
        6,
        0,
        Math.abs((6 - milestonesRetentionArray[6][1]) / milestonesRetentionArray[6][1]),
        0
    ]);
    milestonesRetentionArray[7][2] = (milestonesRetentionArray[6][2] * (1 - milestonesRetentionArray[7][3]));
    milestonesRetentionArray[7][4] = milestonesRetentionArray[7][2] + D1D90RetentionPointIncrease;

    // 90 Day User Retention Part #1
    _90DayUserRetentionTotalPercentage = pc(milestonesRetentionArray[7][4]);

    // --- LTV data ---
    var D90RetentionRateBench = milestonesRetentionArray[7][2] / 100;
    var annualChurnBench = 1 - D90RetentionRateBench;
    var annualChurnImproved = 1 - _90DayUserRetentionTotalPercentage;
    var monthlyChurnBench = 1 - (Math.pow((1 - annualChurnBench), (1 / 12)));
    var monthlyChurnImproved = 1 - (Math.pow((1 - annualChurnImproved), (1 / 12)));
    var userLifetimeMonthsBench = 1 / monthlyChurnBench;
    var userLifetimeMonthsImproved = 1 / monthlyChurnImproved;

    // 90 Day User Retention Part #2
    _90DayUserRetentionFrom = D90RetentionRateBench;
    _90DayUserRetentionDiff = (_90DayUserRetentionTotalPercentage - _90DayUserRetentionFrom) / _90DayUserRetentionFrom;

    // WEEKLY ACTIVE USERS
    weeklyActiveUsersTotal = monthlyDownloads * _90DayUserRetentionTotalPercentage;
    weeklyActiveUsersFrom = monthlyDownloads * D90RetentionRateBench;
    weeklyActiveUsersDiff = (weeklyActiveUsersTotal - weeklyActiveUsersFrom) / weeklyActiveUsersFrom;

    // LIFETIME VALUE
    consumerLifeTimeValueTotal = userLifetimeMonthsImproved * ARPUMonthly;
    consumerLifeTimeValueFrom = userLifetimeMonthsBench * ARPUMonthly;
    consumerLifeTimeValueDiff = (consumerLifeTimeValueTotal - consumerLifeTimeValueFrom) / consumerLifeTimeValueFrom;

    //************************************************************************* */

    if (debug) {
        // ***** LOGS *******
        console.log('/////////////////////////// CONSUMER APP ////////////////////////////////////////////');
        log('INCREASE IN USER ACTIVATION:', consumer_increaseInUserActivation);
        log('Improved UAR Percentage', consumer_improvedUARPercentage);

        console.log('------------ BENCHMARKS ------------');
        log('UAR Percentage', consumer_UARPercentage);
        log('ARPU Monthly', ARPUMonthly);
        log('Monthly Downloads', monthlyDownloadsVal);

        console.log('------------ RETENTION DATA ------------');
        log('RETENTION DATA PERCENTAGE', RETENTION_DATA_PERCENTAGE);
        log('D1 Retention Rate Bench', D1RetentionRateBench);
        log('D1 Retention Rate Improved', D1RetentionRateImproved);
        log('D1-D90 retention point increase', D1D90RetentionPointIncrease);

        console.log('------------ LTV DATA ------------');
        log('D90 Retention Rate Bench', D90RetentionRateBench);
        log('Annual Churn Bench', annualChurnBench);
        log('Annual Churn Improved', annualChurnImproved);
        log('Monthly Churn Bench', monthlyChurnBench);
        log('Monthly Churn Imrpoved', monthlyChurnImproved);
        log('User Lifetime Months Bench', userLifetimeMonthsBench);
        log('User Lifetime Months Improved', userLifetimeMonthsImproved);

        console.log('------------ 90-DAY USER RETENTION ------------');
        log('_90DayUserRetentionTotalPercentage', _90DayUserRetentionTotalPercentage);
        log('_90DayUserRetentionFrom', _90DayUserRetentionFrom);
        log('_90DayUserRetentionDiff', _90DayUserRetentionDiff);

        console.log('------------ WEEKLY ACTIVE USERS ------------');
        log('Weekly Active Users Total', weeklyActiveUsersTotal);
        log('Weekly Active Users From', weeklyActiveUsersFrom);
        log('Weekly Active Users Diff', weeklyActiveUsersDiff);

        console.log('------------ LIFETIME VALUE ------------');
        log('LifeTime Value Total', consumerLifeTimeValueTotal);
        log('LifeTime Value From', consumerLifeTimeValueFrom);
        log('LifeTime Value Diff', consumerLifeTimeValueDiff);;


        console.log('------------ Milestones Retention ------------');
        console.table(milestonesRetentionArray);

        console.log('///////////////////////////////////////////////////////////////////////');
    }
}

function recalculateConsumer() {
    calulateCustomerVariables(
        consumer_increaseInUserActivationVal = consumerSliderValue,
        consumer_UARPercentageVal = parseFloat($('#txtUserActivationRateCustomer').val()),
        ARPUMonthlyVal = parseFloat($('#txtAvgMonthlyRevenuePerUser').val()),
        monthlyDownloadsVal = parseFloat($('#txtMonthlyAppDownloads').val())
    );
    setCustomerUIValues();
    updateCustomerChart();
}

function setCustomerUIValues() {

    if ($('#consumerSliderValue').text() == "0") {
      $('#90DayUserRetentionFromUI').hide();
      $('.consumer-header-arrow-sm').hide();
      $('.consumer-header-up-text').hide();
      $('.from').hide();
    } else if ($('#consumerSliderValue').text() != "0") {
      $('#90DayUserRetentionFromUI').show();
      $('.consumer-header-arrow-sm').show();
      $('.consumer-header-up-text').show();
      $('.from').show();
    }

    var _90DayUserRetentionTotalVal = (_90DayUserRetentionTotalPercentage == _90DayUserRetentionFrom ? '--' : (Math.round((_90DayUserRetentionTotalPercentage * 100) * 100) / 100) + '%');
    $('#90DayUserRetentionTotalUI').html(_90DayUserRetentionTotalVal);
    var _90DayUserRetentionFromVal = Math.round((_90DayUserRetentionFrom * 100) * 100) / 100;
    $('#90DayUserRetentionFromUI').html(_90DayUserRetentionFromVal + '%');
    var _90DayUserRetentionDiffVal = Math.round((_90DayUserRetentionDiff * 100) * 100) / 100;
    $('#90DayUserRetentionDiffPercentageUI').html(_90DayUserRetentionDiffVal + '%');

    var weeklyActiveUsersTotalVal = (weeklyActiveUsersTotal == weeklyActiveUsersFrom ? '--' : Math.round(weeklyActiveUsersTotal));
    $('#weeklyActiveUsersTotalUI').html(weeklyActiveUsersTotalVal);
    var weeklyActiveUsersFromVal = Math.round(weeklyActiveUsersFrom);
    $('#weeklyActiveUsersFromUI').html(weeklyActiveUsersFromVal);
    var weeklyActiveUsersDiffVal = Math.round((weeklyActiveUsersDiff * 100).toFixed(2) * 100) / 100;
    $('#weeklyActiveUsersDiffUI').html(weeklyActiveUsersDiffVal + '%');

    var consumerLifeTimeValueTotalVal = (consumerLifeTimeValueTotal == consumerLifeTimeValueFrom ? '--' : numberFormatToCurrency.format(Math.round(consumerLifeTimeValueTotal * 100) / 100));
    $('#consumerLifetimeValueTotalUI').html(consumerLifeTimeValueTotalVal);
    var consumerLifeTimeValueFromVal = numberFormatToCurrency.format(Math.round(consumerLifeTimeValueFrom * 100) / 100);
    $('#consumerLifetimeValueFromUI').html(consumerLifeTimeValueFromVal);
    var consumerLifeTimeValueDiffVal = Math.round((consumerLifeTimeValueDiff * 100).toFixed(2) * 100) / 100;
    $('#consumerLifetimeValueDiffUI').html(consumerLifeTimeValueDiffVal + '%');
    $('#uarTotalCunsumerUI').text(((consumer_UARPercentage * (1 + consumer_increaseInUserActivation)) * 100).toFixed(1) + '%');

    $('#txtUserActivationRateCustomer').val(consumer_UARPercentage * 100);
    $('#txtAvgMonthlyRevenuePerUser').val(ARPUMonthly);
    $('#txtMonthlyAppDownloads').val(monthlyDownloads);
}

function setConsumerChartData() {
    return {
        labels: milestonesRetentionArray.map(x => x[0]),
        datasets: [{
                data: milestonesRetentionArray.map(x => x[2]),
                fill: true,
                borderColor: '#5EC887', // Add custom color border (Line)
                backgroundColor: '#E3FAEC', // Add custom color background (Points and Fill)
                borderWidth: 1 // Specify bar border width
            },
            {
                data: milestonesRetentionArray.map(x => x[4]),
                fill: true,
                borderColor: '#3A975E', // Add custom color border (Line)
                backgroundColor: '#91f4c3', // Add custom color background (Points and Fill)
                borderWidth: 1 // Specify bar border width
            }
        ]
    };
}

function updateCustomerChart() {
    if (consumerCalculatorChart != undefined) {

        consumerCalculatorChart.data = setConsumerChartData(
            milestonesRetentionArray.map(x => x[0]),
            milestonesRetentionArray.map(x => x[2]),
            milestonesRetentionArray.map(x => x[4]));

        consumerCalculatorChart.update();
    }
}